import { BitkitButton, BitkitDialog, BitkitLink } from '@bitrise/bitkit-v2';
import { Text } from '@chakra-ui/react/text';
import { ReactNode } from 'react';

import URLs from '@/enums/urls';

type ErrorDialogProps = {
  bodyContent?: ReactNode;
  closeText?: string;
  isVisible: boolean;
  onClose: VoidFunction;
  text?: ReactNode;
  title?: string;
};

const ErrorDialog = ({
  bodyContent,
  closeText = 'Close',
  isVisible,
  onClose,
  text = (
    <>
      We ran into an unknown problem. Please try again. If the problem persists, contact{' '}
      <BitkitLink colorVariant="purple" href={URLs.CONTACT_SUPPORT} isExternal>
        Bitrise Support
      </BitkitLink>
      .
    </>
  ),
  title = 'Unexpected error occurred',
}: ErrorDialogProps) => (
  <BitkitDialog
    title={title}
    open={isVisible}
    onOpenChange={({ open }) => !open && onClose()}
    footerButtons={
      <BitkitButton variant="secondary" onClick={onClose}>
        {closeText}
      </BitkitButton>
    }
  >
    {bodyContent || <Text>{text}</Text>}
  </BitkitDialog>
);

export default ErrorDialog;
